/* ============================================================
   assets/int-acc-clamp.js                   INTENTION — 2026-09-04
   THE OPEN ACCORDION IS CLIPPED TO A READ MORE, ON DESKTOP.

   Nils: "the frame print becomes very long. Can we do something so the whole
   section starts by being equal to the bundle box in height, so maybe some of
   the text in the unfolded text is a ream more button... Or make it unfolded
   completely if its legal and still good for AI and Google and SEO etc."

   ⚑ CLIPPED, NEVER REMOVED — THIS IS THE SEO ANSWER. The full text stays in
   the DOM at all times; only its height is limited. Search engines and the AI
   crawlers read the served HTML, so nothing is lost by clipping, whereas
   loading the rest on click would hide it from anything that does not run
   JavaScript. Do not "improve" this by moving the text out of the markup.

   ⚑ THE TARGET IS MEASURED FROM THE BUNDLE BOX, NOT HARD-CODED. Nils asked
   for the section to start the same height as that box, so the script reads
   the right column and subtracts what the left column spends on its four
   headers and its kicker. Measured on framed print at 1440: right column 309,
   four headers 232, kicker 36 — which leaves 41px for the body, less than two
   lines. So there is a floor: the body never clips below MIN_BODY, and the
   column lands near 390 instead of the 1259 it was. The exact match Nils
   asked for is not reachable while four headers are showing; this is as close
   as it goes without hiding a header.

   ⚑ ONCE OPENED, NEVER RE-CLIPPED. A reader who pressed Read more has said
   what they want; re-clipping when they open Care as well would be a trap.

   ⚑ 2026-09-05, IT RUNS ON THE PHONE TOO. Nils: "The unfold on Quality is too
   long here too. Make the read more unfold here too." The note that used to
   sit here said there was no second column to match on a phone, and that had
   just stopped being true: assets/int-pdp-colswap.js now runs its swap at
   every width, so the bundle box has moved into .int-mwi-col--rep on mobile
   as well. The row stacks rather than sitting side by side, so "match the
   bundle box" is no longer a literal alignment there — but the arithmetic
   still gives the right answer. Measured on a 375px phone: the bundle box is
   335, the four headers and the kicker spend about 268, so the target falls
   under the floor and the body clips at MIN_BODY, 120px, against the 349 it
   was. Four lines and a Read more.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intAccClamp) return;
  window.__intAccClamp = true;

  /* ⚑ 2026-09-05: TELL THE CRITICAL CSS THAT THIS SCRIPT IS ALIVE, before anything else.
     `snippets/int-critical-css.liquid` item 18 clips the open body to MIN_BODY at first paint so the
     page is not painted 1,057px too tall and then collapsed. That rule is scoped to
     `html.js:not(.int-acc-ready)`, so this one line is what hands control back to the inline
     max-height below and lets unclamp() actually unclamp: removing an inline style cannot remove a
     stylesheet rule. Add it here, not inside apply(), so an early return in apply() can never leave a
     reader with clipped text and no way to open it. */
  document.documentElement.classList.add('int-acc-ready');

  /* every width since 2026-09-05 — see the header note. Kept as a query
     rather than dropped so narrowing it back is a one-line change. */
  var MQ = '(min-width: 0px)';
  var MIN_BODY = 120;      /* never clip tighter than this */
  var SLACK = 40;          /* don't bother clipping to save less than this */
  var expanded = false;

  function target() {
    var rep = document.querySelector('.int-mwi-col--rep');
    var acc = document.querySelector('.int-mwi-col--acc');
    if (!rep || !acc) return null;
    var spent = 0;
    acc.querySelectorAll('.int-accordion__title').forEach(function (t) {
      spent += t.getBoundingClientRect().height;
    });
    var kick = acc.querySelector('.int-accordion-headline');
    if (kick) spent += kick.getBoundingClientRect().height + 16;
    return Math.max(MIN_BODY, Math.round(rep.getBoundingClientRect().height - spent));
  }

  function open() {
    return document.querySelector('.int-mwi-col--acc .int-accordion--open .int-accordion__body');
  }

  function unclamp(body) {
    if (!body) return;
    body.style.removeProperty('max-height');
    body.classList.remove('int-acc-clipped');
    var btn = body.parentNode && body.parentNode.querySelector('.int-acc-more');
    if (btn) btn.remove();
  }

  function apply() {
    var body = open();
    if (!body) return;
    if (expanded || !window.matchMedia(MQ).matches) { unclamp(body); return; }

    var t = target();
    if (t === null) return;
    /* nothing to gain if the body is already about that tall */
    body.style.removeProperty('max-height');
    var full = body.scrollHeight;
    if (full <= t + SLACK) { unclamp(body); return; }

    body.style.maxHeight = t + 'px';
    body.classList.add('int-acc-clipped');

    if (!body.parentNode.querySelector('.int-acc-more')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'int-acc-more';
      btn.textContent = (document.documentElement.lang || 'en').slice(0, 2) === 'da'
        ? 'Læs mere' : 'Read more';
      btn.addEventListener('click', function () {
        expanded = true;
        unclamp(open());
      });
      body.parentNode.insertBefore(btn, body.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  /* the column swap and the row are both built after DOMContentLoaded */
  setTimeout(apply, 700);
  var t2;
  window.addEventListener('resize', function () {
    clearTimeout(t2);
    t2 = setTimeout(apply, 150);
  }, false);
})();
